var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnsbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    transform: "translate(-331.75 -1137.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 24,
    height: 24,
    transform: "translate(331.75 1137.75)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "document-normal",
    transform: "translate(331.75 1137.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M10,6.75c-.96,0-2.75,0-2.75-2.75S9.04,1.25,10,1.25h4c.96,0,2.75,0,2.75,2.75,0,.96,0,2.75-2.75,2.75ZM8.75,4c0,1.25.26,1.25,1.25,1.25h4c1.25,0,1.25-.26,1.25-1.25,0-1.25-.26-1.25-1.25-1.25H10C9.01,2.75,8.75,2.75,8.75,4Z",
    fill: "#9e3323",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M9,22.75c-5.62,0-6.75-2.58-6.75-6.75V10c0-4.56,1.65-6.51,5.71-6.72a.75.75,0,0,1,.79.71.742.742,0,0,1-.71.78C5.2,4.93,3.75,5.78,3.75,10v6c0,3.7.73,5.25,5.25,5.25h6c4.52,0,5.25-1.55,5.25-5.25V10c0-4.22-1.45-5.07-4.29-5.23a.751.751,0,1,1,.08-1.5c4.06.22,5.71,2.17,5.71,6.72v6c0,4.18-1.13,6.76-6.75,6.76Z",
    fill: "#9e3323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsbtn);
export default __webpack_public_path__ + "static/media/ansbtn.f249eb2b02829467ffdb67fa2e0084e7.svg";
export { ForwardRef as ReactComponent };